import { operatorApiFetch } from './apiService';

export const warehouseZoneService = {
  getRecords: async (params) => {
    const response = await operatorApiFetch('warehouse_zones', {
      method: 'GET',
      params
    });
    return response.json();
  },

  create: async (data) => {
    const response = await operatorApiFetch('warehouse_zones', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ warehouse_zone: data })
    });
    return response.json();
  },

  update: async (id, data) => {
    const response = await operatorApiFetch(`warehouse_zones/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ warehouse_zone: data })
    });
    return response.json();
  },

  delete: async (id, params = {}) => {
    const query = new URLSearchParams();
    if (params.replacement_zone_id) query.set('replacement_zone_id', params.replacement_zone_id);
    if (params.clear_zone) query.set('clear_zone', 'true');
    const queryStr = query.toString();
    const url = `warehouse_zones/${id}${queryStr ? `?${queryStr}` : ''}`;

    const response = await operatorApiFetch(url, {
      method: 'DELETE'
    });
    return response.json();
  }
};
